import lodashGet from "lodash/get";

import { httpGet } from "@/services/api.service";
import {
  ENDPOINT_CYBER_PROFILE,
  ENDPOINT_CYBER_PROFILE_CONFIG,
} from "@/common/constants/api";

export { _getCyberInfo as getCyberInfo };
export { _getCyberProfileConfig as getCyberProfileConfig };
export { _getCyberProfileData as getCyberProfileData };

const _getCyberInfo = async (params) => {
  try {
    let id = 0;
    if (!params.id) {
      console.warn("Issue getting cyber info in cyber.service.js. No id set.");
      return false;
    }

    // set the id for sections and parentId for subsectios
    if (params.parent) {
      id = params.parent;
    } else {
      id = params.id;
    }

    const endpoint = `${ENDPOINT_CYBER_PROFILE}/${id}`;

    const RESULT = await httpGet({ url: encodeURI(endpoint) });
    const { data } = JSON.parse(RESULT);

    if (lodashGet(data, "cyberProfile")) {
      return data.cyberProfile;
    }

    console.error(
      "Issue getting cyber info in cyber.service.js. No data.result found."
    );
    return null;
  } catch (error) {
    console.error(
      "Issue getting cyber info in cyber.service.js",
      JSON.stringify(error)
    );
    return null;
  }
};

const _getCyberProfileConfig = async () => {
  try {
    const url = ENDPOINT_CYBER_PROFILE_CONFIG;
    const result = await httpGet({ url });
    const { data } = JSON.parse(result);

    return data;
  } catch (error) {
    Promise.reject(
      "Issue getting Cyber profile config in cyber.service.js: " +
        JSON.stringify(error)
    );
    return null;
  }
};

const _getCyberProfileData = async (sections) => {
  try {
    let subSections = [];
    await Promise.all(
      sections.map(async (section, index) => {
        section.order = index + 1;
        let subSection = await _getCyberInfo(section);
        if (subSection) {
          const formattedSubSections = subSection.map((item, index) => ({
            id: item.id,
            title: item.title,
            parent: section.id,
            order: section.order + (index + 1) / 100,
            body: item.body,
          }));
          subSections.push(...formattedSubSections);
        } else {
          console.error("Missing data for cyber profile: " + section.id);
        }
      })
    );
    if (subSections && subSections.length > 0) {
      sections.push(...subSections);
    } else {
      throw "Error getting cyber profile data.";
    }
    return sections;
  } catch (error) {
    console.error(
      "Issue getting cyber data in cyber.service.js",
      JSON.stringify(error)
    );
    return null;
  }
};
